<template>
	<v-row no-gutters>
		<v-col cols="12" md="6" class="pr-md-1">
			<table width="100%" class="mt-4 show-dialog-table show-dialog-table--form">
				<tbody>
					<ShowDetailRecord :columnName="'事例番号'">
						<template v-slot:value>
							<v-text-field
								v-model="problemCase.case_number"
								background-color="white"
								outlined
								dense
								hide-details
							/> </template
					></ShowDetailRecord>
					<ShowDetailRecord :columnName="'事例名'">
						<template v-slot:value>
							<v-text-field
								v-model="problemCase.name"
								background-color="white"
								outlined
								dense
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'対象タイプ'">
						<template v-slot:value>
							<v-select
								v-model="problemCase.case_type"
								:items="case_types"
								item-text="name"
								item-value="id"
								background-color="white"
								outlined
								dense
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'対象分類'">
						<template v-slot:value>
							<v-select
								v-model="problemCase.product_category_id"
								:items="categories"
								item-text="name"
								item-value="id"
								@change="changeCategoryId"
								background-color="white"
								outlined
								dense
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'対象子分類'">
						<template v-slot:value>
							<v-select
								v-model="problemCase.product_sub_category_id"
								:items="setSubCategories"
								item-text="name"
								item-value="id"
								background-color="white"
								outlined
								dense
								hide-details
								:no-data-text="
									problemCase.product_category_id
										? 'データが見つかりません。'
										: '対象分類を選択してください。'
								"
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'対象製品名'">
						<template v-slot:value>
							<IncrementalSearchForm
								:classArray="['bg-white']"
								:value.sync="problemCase.product_id"
								:itemText="'product_name_with_product_number'"
								:targetName="'製品'"
								:url="`/erp/v1/incremental/products`"
								:initialItems="products"
								hideDetails
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord
						:columnName="'添付ファイル'"
						:tdStyle="{ backgroundColor: 'white', borderBottom: '1px solid whitesmoke' }"
					>
						<template v-slot:value>
							<v-btn color="secondary" class="mt-2" @click="$refs.uploadFile.click()">
								<v-icon class="mr-1">mdi-file-document-plus-outline</v-icon>
								添付書類を追加
								<input
									type="file"
									class="d-none"
									ref="uploadFile"
									@change="addFiles($event)"
									multiple
								/>
							</v-btn>

							<div class="file-area mt-2">
								<span v-if="allFiles < 1" class="filename">選択されていません</span>
								<template v-else>
									<v-chip
										class="ma-1 mt-2"
										close
										outlined
										label
										color="primary"
										:key="file.id"
										@click:close="deleteFile(i)"
										v-for="(file, i) in existingFiles"
									>
										<v-icon class="mr-1">mdi-paperclip</v-icon>
										{{ file.name }}
									</v-chip>
									<v-chip
										class="ma-1 mt-2"
										close
										outlined
										label
										color="primary"
										@click:close="removeFile(i)"
										v-for="(file, i) in files"
										:key="file.name"
									>
										<v-icon class="mr-1">mdi-paperclip</v-icon>
										{{ file.name }}
									</v-chip>
								</template>
							</div>
						</template>
					</ShowDetailRecord>
				</tbody>
			</table>
		</v-col>
		<v-col cols="12" md="6" class="pl-md-1">
			<table width="100%" class="mt-4 show-dialog-table show-dialog-table--form">
				<tbody>
					<ShowDetailRecord :columnName="'備考'">
						<template v-slot:value>
							<v-textarea
								v-model="problemCase.description"
								background-color="white"
								auto-grow
								outlined
								dense
								hide-details
							/> </template
					></ShowDetailRecord>
				</tbody>
			</table>
		</v-col>
	</v-row>
</template>

<script>
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import IncrementalSearchForm from "../../shared/IncrementalSearchForm.vue"

export default {
	props: {
		problem_case: {
			type: Object,
			required: true,
		},
		categories: {
			type: Array,
			required: true,
		},
		case_types: {
			type: Array,
			required: true,
		},
		products: {
			type: Array,
			default: () => [],
		},
		file_data: {
			type: Array,
			default: () => [],
		},
		existing_files: {
			type: Array,
			default: () => [],
		},
		deleted_files: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		ShowDetailRecord,
		IncrementalSearchForm,
	},
	data() {
		return {
			rules,
			existingFiles: [],
		}
	},
	methods: {
		changeCategoryId() {
			this.problemCase.product_sub_category_id = ""
		},
		removeFile(index) {
			this.files.splice(index, 1)
		},
		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				this.files.push(file[1])
			})
		},
		deleteFile(index) {
			this.deleted_files.push(this.existingFiles.splice(index, 1)[0])
			this.$emit("update:deleted_files", this.deleted_files)
		},
	},
	computed: {
		setSubCategories() {
			const categoryId = this.problemCase.product_category_id
			if (!categoryId) {
				return []
			} else {
				const category = this.categories.find((c) => c.id == categoryId)
				if (!category) return []
				return category.product_sub_categories
			}
		},

		problemCase: {
			get() {
				return this.problem_case
			},
			set(value) {
				this.$emit("update:problem_case", value)
			},
		},
		files: {
			get() {
				return this.file_data
			},
			set(value) {
				this.$emit("update:file_data", value)
			},
		},
		allFiles() {
			return this.existingFiles.length + this.files.length
		},
	},
	watch: {
		existing_files: {
			handler(val) {
				this.existingFiles = val
			},
			deep: true,
		},
	},
}
</script>
